(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-functions-quiz]';

  function track(eventName, detail) {
    const payload = Object.assign({ event: eventName }, detail || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', eventName);
    } catch (error) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, detail || {});
    } catch (error) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, detail || {});
      }
    } catch (error) {}
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToElement(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  function getOfferRoot() {
    return document.querySelector('[id$="__quiz_offer"] [data-functions-product]');
  }

  function selectedOfferPrice() {
    const offer = getOfferRoot();
    const selected = offer && offer.querySelector('[data-variant-wrap].is-active');
    return selected && (selected.dataset.variantOfferPrice || selected.dataset.variantPrice);
  }

  function updateClosingButton() {
    const price = selectedOfferPrice();
    document.querySelectorAll('[data-fnq-buy]').forEach((button) => {
      if (!button.dataset.baseLabel) button.dataset.baseLabel = button.textContent.trim();
      button.textContent = price ? button.dataset.baseLabel + ' | ' + price : button.dataset.baseLabel;
    });
  }

  function init(root) {
    if (!root || root.dataset.fnqInitialized === 'true') return;
    root.dataset.fnqInitialized = 'true';

    const controller = new AbortController();
    root._fnqController = controller;
    const signal = controller.signal;
    const quiz = root.querySelector('[data-fnq-quiz]');
    const pdp = root.querySelector('[data-fnq-pdp]');
    const panel = root.querySelector('[data-fnq-panel]');
    const screens = Array.from(root.querySelectorAll('[data-fnq-screen]'));
    const back = root.querySelector('[data-fnq-back]');
    const stepLabel = root.querySelector('[data-fnq-step-label]');
    const progress = root.querySelector('[data-fnq-progress]');
    const answers = {};
    let current = 0;
    let analysisTimer = 0;
    let started = false;
    let recommendedPlan = 2;

    function answerLabel(key) {
      const answer = answers[key];
      if (!answer) return 'Noch offen';
      if (Array.isArray(answer)) return answer.map((item) => item.label).join(', ');
      return answer.label;
    }

    function calculateProfile() {
      const nightPattern = answers.nightPattern;
      if (nightPattern && nightPattern.profile && nightPattern.profile !== 'none') return nightPattern.profile;

      const scores = { head: 0, night: 0, morning: 0 };
      Object.keys(answers).forEach((key) => {
        const entries = Array.isArray(answers[key]) ? answers[key] : [answers[key]];
        entries.forEach((entry) => {
          if (entry && scores[entry.profile] !== undefined) scores[entry.profile] += 1;
        });
      });
      return Object.keys(scores).sort((a, b) => scores[b] - scores[a])[0] || 'morning';
    }

    function profileData(profile) {
      return {
        name: root.dataset['profile' + profile.charAt(0).toUpperCase() + profile.slice(1) + 'Name'],
        copy: root.dataset['profile' + profile.charAt(0).toUpperCase() + profile.slice(1) + 'Copy']
      };
    }

    function fillResult() {
      const profile = calculateProfile();
      const data = profileData(profile);
      root.querySelectorAll('[data-fnq-profile-name]').forEach((element) => { element.textContent = data.name || ''; });
      root.querySelectorAll('[data-fnq-profile-copy]').forEach((element) => { element.textContent = data.copy || ''; });
      const night = root.querySelector('[data-fnq-result-night]');
      const morning = root.querySelector('[data-fnq-result-morning]');
      const moment = root.querySelector('[data-fnq-result-moment]');
      if (night) night.textContent = answerLabel('nightPattern');
      if (morning) morning.textContent = answerLabel('desiredMorning');
      if (moment) moment.textContent = answerLabel('desiredMoment');
    }

    function applyOfferRecommendation() {
      const offer = getOfferRoot();
      if (!offer) return;

      offer.querySelectorAll('.fnq-recommendation-badge').forEach((badge) => badge.remove());
      // Langer Zeitraum angegeben (nicht übersprungen) – vor dem Fallback merken
      const askedLong = recommendedPlan >= 3;
      // Gibt es das empfohlene Paket nicht (z. B. Aktion nur mit 1 und 2+1),
      // greift das größte vorhandene Paket.
      let recommended = offer.querySelector('[data-variant-qty="' + recommendedPlan + '"]');
      if (!recommended) {
        Array.from(offer.querySelectorAll('[data-variant-wrap][data-variant-qty]')).forEach((wrap) => {
          if (!recommended || parseInt(wrap.dataset.variantQty, 10) > parseInt(recommended.dataset.variantQty, 10)) recommended = wrap;
        });
        if (!recommended) return;
        recommendedPlan = parseInt(recommended.dataset.variantQty, 10) || recommendedPlan;
      }

      const card = recommended.querySelector('[data-variant-card]');
      // Trägt die Karte schon ein Ecken-Label (z. B. Aktion), kein zweites darüberlegen
      if (card && !card.querySelector('.fw-plan__ribbon, .fn2-phero__ribbon')) {
        const badge = document.createElement('span');
        badge.className = 'fn2-phero__ribbon fn2-phero__ribbon--dark fnq-recommendation-badge';
        badge.textContent = 'Für dich empfohlen';
        card.prepend(badge);
      }

      recommended.click();

      const duration = answerLabel('duration');
      const hint = offer.querySelector('.fn2-phero__plans-hint');
      if (hint) {
        const nameEl = recommended.querySelector('.fw-plan__badge-m') || recommended.querySelector('.fw-plan__name');
        const pack = nameEl ? nameEl.textContent.trim() : '';
        const nights = recommendedPlan * 30 + ' Nächte';
        const label = pack ? pack + ' (' + nights + ')' : nights;
        hint.textContent = askedLong
          ? 'Du hast angegeben: ' + duration + '. Deshalb empfehlen wir ' + label + ', damit du nicht nach wenigen Abenden über eine neue Routine urteilen musst.'
          : 'Für dich empfohlen: ' + label + ' – genug Zeit, damit eine neue Abendroutine wirken kann.';
      }

      document.body.dataset.fnqPlan = String(recommendedPlan);
      window.setTimeout(updateClosingButton, 0);
      track('quiz_plan_recommended', { plan_months: recommendedPlan });
    }

    root._fnqApplyOffer = applyOfferRecommendation;

    function fillPdp(skipped) {
      const profile = skipped ? 'morning' : calculateProfile();
      const titles = {
        head: root.dataset.headTitle,
        night: root.dataset.nightTitle,
        morning: root.dataset.morningTitle
      };
      const title = root.querySelector('[data-fnq-offer-title]');
      const copy = root.querySelector('[data-fnq-offer-copy]');
      const fit = root.querySelector('[data-fnq-personal-fit]');

      if (title) title.textContent = skipped ? root.dataset.genericTitle : titles[profile];
      if (copy) {
        copy.textContent = skipped
          ? copy.textContent
          : 'Du hast beschrieben: ' + answerLabel('nightPattern') + ' Gleichzeitig wünschst du dir ' + answerLabel('desiredMorning') + '. Hier siehst du, warum RESTORE zu diesem Ziel passen könnte.';
      }

      if (fit) fit.hidden = skipped;
      const fitNight = root.querySelector('[data-fnq-fit-night]');
      const fitMorning = root.querySelector('[data-fnq-fit-morning]');
      const fitRoutine = root.querySelector('[data-fnq-fit-routine]');
      if (fitNight) fitNight.textContent = answerLabel('nightPattern');
      if (fitMorning) fitMorning.textContent = answerLabel('desiredMorning');
      if (fitRoutine) fitRoutine.textContent = answerLabel('routineTime');

      root.querySelectorAll('[data-fnq-stage]').forEach((stage) => {
        stage.classList.toggle('is-focus', stage.dataset.fnqStage === profile);
      });
      const morningStage = root.querySelector('[data-fnq-stage-morning]');
      if (morningStage && !skipped) morningStage.textContent = 'Dein Maßstab: ' + answerLabel('desiredMorning') + '.';
      const match = root.querySelector('[data-fnq-match-personal]');
      if (match && !skipped) match.textContent = 'Für dich geht es nicht um mehr Leistung. Es geht um: ' + answerLabel('desiredMoment') + '.';

      const duration = answers.duration;
      recommendedPlan = !skipped && duration && duration.value !== '1' ? 3 : 2;
    }

    function completeQuiz(skipped) {
      window.clearTimeout(analysisTimer);
      fillPdp(skipped);
      quiz.hidden = true;
      pdp.hidden = false;
      document.body.classList.add('fnq-complete');
      root.dataset.fnqCompleted = 'true';
      window.setTimeout(applyOfferRecommendation, 0);
      window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      track('quiz_completed', { skipped: Boolean(skipped), profile: skipped ? 'direct' : calculateProfile(), recommended_months: recommendedPlan });
    }

    function showScreen(index, focusPanel) {
      window.clearTimeout(analysisTimer);
      current = Math.max(0, Math.min(screens.length - 1, index));
      screens.forEach((screen, screenIndex) => { screen.hidden = screenIndex !== current; });
      if (back) back.hidden = current === 0;
      if (stepLabel) stepLabel.textContent = 'Schritt ' + (current + 1) + ' von ' + screens.length;
      if (progress) progress.style.width = (((current + 1) / screens.length) * 100) + '%';

      const active = screens[current];
      if (active && active.dataset.stepType === 'result') fillResult();
      if (active && active.dataset.stepType === 'analysis') {
        const delay = parseInt(active.dataset.delay, 10) || 1800;
        analysisTimer = window.setTimeout(() => showScreen(current + 1, true), delay);
      }
      if (focusPanel && panel) panel.focus({ preventScroll: true });
    }

    function advance() {
      if (current >= screens.length - 1) {
        completeQuiz(false);
        return;
      }
      showScreen(current + 1, true);
    }

    root.addEventListener('click', (event) => {
      const option = event.target.closest('[data-fnq-option]');
      if (option && root.contains(option)) {
        const screen = option.closest('[data-fnq-screen]');
        const key = screen.dataset.questionKey;
        const selection = screen.dataset.selection;
        const entry = {
          value: option.dataset.value,
          label: option.dataset.answerLabel,
          profile: option.dataset.profile || 'none'
        };

        if (!started) {
          started = true;
          track('quiz_started');
        }

        if (selection === 'multi') {
          const chosen = Array.isArray(answers[key]) ? answers[key].slice() : [];
          const existing = chosen.findIndex((item) => item.value === entry.value);
          if (existing >= 0) {
            chosen.splice(existing, 1);
          } else {
            const max = parseInt(screen.dataset.max, 10) || 6;
            if (chosen.length >= max) {
              const error = screen.querySelector('[data-fnq-error]');
              if (error) error.textContent = 'Bitte wähle höchstens ' + max + ' Punkte.';
              return;
            }
            chosen.push(entry);
          }
          answers[key] = chosen;
          screen.querySelectorAll('[data-fnq-option]').forEach((button) => {
            button.setAttribute('aria-pressed', String(chosen.some((item) => item.value === button.dataset.value)));
          });
          const error = screen.querySelector('[data-fnq-error]');
          if (error) error.textContent = '';
        } else {
          answers[key] = entry;
          screen.querySelectorAll('[data-fnq-option]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === option));
          });
          track('quiz_step_completed', { step_key: key, answer: entry.value });
          window.setTimeout(advance, prefersReducedMotion() ? 0 : 180);
        }
        return;
      }

      const next = event.target.closest('[data-fnq-next]');
      if (next && root.contains(next)) {
        const screen = next.closest('[data-fnq-screen]');
        if (screen && screen.dataset.selection === 'multi') {
          const selected = answers[screen.dataset.questionKey];
          if (!selected || !selected.length) {
            const error = screen.querySelector('[data-fnq-error]');
            if (error) error.textContent = 'Bitte wähle mindestens eine Antwort.';
            return;
          }
        }
        advance();
        return;
      }

      if (event.target.closest('[data-fnq-skip]')) {
        completeQuiz(true);
        return;
      }

      if (event.target.closest('[data-fnq-scroll-offer]')) {
        scrollToElement(document.querySelector(root.dataset.offerAnchor));
        return;
      }

      if (event.target.closest('[data-fnq-edit]')) {
        document.body.classList.remove('fnq-complete');
        pdp.hidden = true;
        quiz.hidden = false;
        const resultIndex = screens.findIndex((screen) => screen.dataset.stepType === 'result');
        showScreen(resultIndex >= 0 ? resultIndex : screens.length - 1, true);
        window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }, { signal: signal });

    if (back) {
      back.addEventListener('click', () => showScreen(current - 1, true), { signal: signal });
    }

    document.addEventListener('click', (event) => {
      const plan = event.target.closest('[id$="__quiz_offer"] [data-variant-wrap]');
      if (plan) {
        document.body.dataset.fnqPlan = plan.dataset.variantQty || String(recommendedPlan);
        window.setTimeout(updateClosingButton, 0);
      }

      const buy = event.target.closest('[data-fnq-buy]');
      if (!buy) return;
      const offer = getOfferRoot();
      const form = offer && offer.querySelector('form[data-add-to-cart-form]');
      if (form) {
        track('quiz_add_to_cart', { plan_months: parseInt(document.body.dataset.fnqPlan, 10) || recommendedPlan });
        form.requestSubmit();
      } else {
        scrollToElement(offer);
      }
    }, { signal: signal });

    showScreen(0, false);
  }

  function initAll(scope) {
    const context = scope || document;
    if (context.matches && context.matches(ROOT_SELECTOR)) init(context);
    context.querySelectorAll(ROOT_SELECTOR).forEach(init);

    const root = document.querySelector(ROOT_SELECTOR);
    if (root && root.dataset.fnqCompleted === 'true' && typeof root._fnqApplyOffer === 'function') {
      window.setTimeout(root._fnqApplyOffer, 0);
    }
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? event.target
      : event.target.querySelector(ROOT_SELECTOR);
    if (root && root._fnqController) root._fnqController.abort();
  });
})();
